import api from '@pray/shared/utils/api';

export async function retriggerTranslations({
  artistId,
  targetLocaleCodes,
  sourceContentIds,
  sourceContentSeriesIds,
  creditConfirmationId,
}) {
  if (!artistId) {
    throw new Error('Artist ID is required');
  }

  if (
    (!sourceContentIds || sourceContentIds.length === 0) &&
    (!sourceContentSeriesIds || sourceContentSeriesIds.length === 0)
  ) {
    throw new Error('Either sourceContentIds or sourceContentSeriesIds must be provided and not empty');
  }

  const url = `/web/studio/artists/${artistId}/translations/retrigger`;
  const response = await api.executePostRequest(url, {
    target_locale_codes: targetLocaleCodes,
    source_content_ids: sourceContentIds,
    source_content_series_ids: sourceContentSeriesIds,
    ...(creditConfirmationId && { credit_confirmation_id: creditConfirmationId }),
  });

  return response?.data;
}
